import React, { useEffect, useRef } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getDomDistance, getQuery } from '@src/utils/index';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const Banner = () => {

    return (
        <div className={styles.banner}>
            <img src={'https://d.ifengimg.com/w1500_q90_webp/x0.ifengimg.com/feprod/c/2025_7_24/19_10_49/n_banner1.jpg'} className={styles.top} />
        </div>
    );
};

export default errorBoundary(Banner);
